import {
  StyledButton,
  StyledButtonsDiv,
  StyledCopyLinkButton,
  StyledMainWrapper,
  StyledTelegramButton,
  StyledWhatsappButton,
  StyledopyLinkButton,
} from "./ShareButton.style";
import { Button } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import Modal from "components/shared/Modal";
import { useState } from "react";
import { Divider, Grid, IconButton, InputBase, Paper } from "@mui/material";
import Toast from "helper/toast";
import { PuffLoader } from "react-spinners";

export default function ShareButton(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  function copy() {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
  }

  const openWhatsApp = () => {
    window.open(
      `whatsapp://send?text=https://wewell.co.ir/#/product/${props.ProductId}`
    );
  };
  const openTelegram = () => {
    window.open(
      `tg://msg?text=https://wewell.co.ir/#/product/${props.ProductId}`
    );
  };

  return (
    <>
      <StyledMainWrapper>
        <Button onClick={() => setIsOpen(true)} style={{ padding: "0" }}>
          <PuffLoader color={"#009ac2"} size={60} />
          <ShareOutlinedIcon style={{ position: "absolute" }} />
        </Button>
      </StyledMainWrapper>
      <Modal
        show={isOpen}
        onClose={() => setIsOpen(false)}
        title="اشتراک‌ گذاری"
      >
        <StyledButtonsDiv>
          <p className="text">این کالا را با دوستان خود به اشتراک بگذارید!</p>
          <Grid container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <StyledopyLinkButton onClick={copy}>
                <ContentCopyOutlinedIcon style={{ paddingLeft: "8px" }} />
                {!copied ? "کپی کردن لینک" : "کپی شد"}
              </StyledopyLinkButton>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <StyledWhatsappButton onClick={openWhatsApp}>
                <WhatsAppIcon style={{ paddingLeft: "8px" }} />
                واتساپ
              </StyledWhatsappButton>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <StyledTelegramButton onClick={openTelegram}>
                <TelegramIcon style={{ paddingLeft: "5px" }} />
                تلگرام
              </StyledTelegramButton>
            </Grid>
          </Grid>
        </StyledButtonsDiv>
      </Modal>
    </>
  );
}
